import { Box } from "@chakra-ui/react";

import { TableSearchBox } from "@nens/chakra/components";

export type SearchOption<Key extends string | undefined, SearchKey extends string> =
  | {
      key: SearchKey & Key;
      label: string;
      enum?: { key: string; label: string }[];
    }
  | {
      key: Key;
      searchKey: SearchKey;
      label: string;
      enum?: { key: string; label: string }[];
    };

type Props<Key extends string | undefined, SearchKey extends string> = {
  searchField: SearchKey;
  setSearchField: (searchField: SearchKey) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
  searchOptions: SearchOption<Key, SearchKey>[];
};

export const getSearchKey = <Key extends string | undefined, SearchKey extends string>(
  searchField: SearchOption<Key, SearchKey>
) => ("searchKey" in searchField ? searchField.searchKey : searchField.key);

const SearchBox = <Key extends string | undefined, SearchKey extends string>({
  searchField,
  setSearchField,
  searchString,
  setSearchString,
  searchOptions,
}: Props<Key, SearchKey>) => {
  const searchEnum = searchOptions
    .find((field) => searchField === getSearchKey(field))
    ?.enum?.map(({ key, label }): [string, string] => [key, label]);

  return (
    <Box pr="5" flex="0 0 auto">
      <TableSearchBox
        my="5"
        ml="auto"
        w="20"
        value={searchString}
        searchField={searchField}
        setSearchField={setSearchField}
        searchEnum={searchEnum}
        searchFields={searchOptions.map((field) => [getSearchKey(field), field.label])}
        onChange={setSearchString}
        placeholder={"Type om te zoeken"}
        descriptionLabel="Zoek"
      />
    </Box>
  );
};

export { SearchBox };
